// src/pages/Parametros/tabs/TabTemperatura.jsx
import React from 'react';
import {
    Box, TextField, Typography, Paper,
    InputAdornment, Alert,
} from '@mui/material';
import * as Lucide from 'lucide-react';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

export default function TabTemperatura() {
    const { params, updateGroup } = useParametrosAnalise();
    const t = params.temperatura;
    const set = (field, value) => updateGroup('temperatura', { [field]: value });

    const faixaMin = (t.temperaturaProtocolo - t.tolerancia).toFixed(1);
    const faixaMax = (t.temperaturaProtocolo + t.tolerancia).toFixed(1);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 3 }}>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Protocolo de temperatura
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <TextField
                        label="Temperatura de protocolo"
                        type="number"
                        value={t.temperaturaProtocolo}
                        onChange={(e) => set('temperaturaProtocolo', Number(e.target.value))}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">°C</InputAdornment>,
                        }}
                        sx={{ width: 240 }}
                    />
                    <TextField
                        label="Tolerância"
                        type="number"
                        value={t.tolerancia}
                        onChange={(e) => set('tolerancia', Number(e.target.value))}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">°C</InputAdornment>,
                        }}
                        inputProps={{ min: 0, step: 0.5 }}
                        sx={{ width: 180 }}
                        helperText="± °C"
                    />
                </Box>
            </Paper>
            <Alert
                severity="info"
                icon={<Lucide.Thermometer />}
                sx={{ fontFamily: 'monospace', fontSize: '0.9rem' }}
            >
                Faixa aceita calculada:&nbsp;
                <strong>{faixaMin}°C – {faixaMax}°C</strong>
                &nbsp;(protocolo {t.temperaturaProtocolo}°C ± {t.tolerancia}°C)
            </Alert>
        </Box>
    );
}
